import _ from "@lodash";
import { withStyles } from "@material-ui/core";
import Viewer, { defaultLayout, Worker } from "@phuocng/react-pdf-viewer";
import "@phuocng/react-pdf-viewer/cjs/react-pdf-viewer.css";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as Helpers from "app/Core/Helpers";
import * as AppActions from "app/store/actions";
import withReducer from "app/store/withReducer";
import MobileDetect from "mobile-detect";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import React from "react";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import XAPPButton from "../Button/XAPPButton";
import PDFReaderDialog from "./PDFReaderDialog";
import * as Actions from "./Store/Actions/PDFReaderActions";
import PDFReaderReducer from "./Store/Reducers/PDFReaderReducer";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const md = new MobileDetect(window.navigator.userAgent);

const styles = () => ({
    iframePDF: {
        width: "100%",
        height: "100%"
    },
    divMain: {
        width: "100%",
        //height: '400px'
    }
});

class PDFReaderApp extends XAPPComponent {

    state = {
        open: false,
        base64: null,
        template: null,
        url: ""
    };

    componentDidMount() {
        this.getDados();
    }

    getDados = () => {
        const { xappRouteParams, documento, downloadFile, getRelatorioTemplate } = this.props;
        if (documento.arquivo && !_.isNull(documento.caminho)) {
            downloadFile(documento, xappRouteParams.empresa);
        }
        else {
            getRelatorioTemplate(documento.idrelatorio);
        }
    };

    componentWillUnmount() {
        this.props.clearReducer();
    }

    componentDidUpdate() {
        if (!_.isNull(this.props.template) &&
            this.props.template.id === this.props.documento.idrelatorio &&
            this.state.url.length < 1) {
            var AStringTemplate = this.translateTemplate();
            this.renderPDF(AStringTemplate);
            this.props.clearReducer();
        }

        if (!_.isNull(this.props.file) &&
            this.props.file.id === this.props.documento.id &&
            this.state.url.length < 1) {
            this.setState(_.set({ ...this.state }, "url", this.props.file.url));
            this.props.clearReducer();
        }

    }

    renderToolbar = (toolbarSlot) => {
        return (
            <React.Fragment>
                <div
                    style={{
                        alignItems: "center",
                        display: "flex",
                        width: "100%",
                    }}
                >
                    <div
                        style={{
                            alignItems: "center",
                            display: "flex",
                            flexGrow: 1,
                            flexShrink: 1,
                            justifyContent: "center",
                        }}
                    >
                        <div className={"viewer-toolbar-item"}>
                            {toolbarSlot.zoomOutButton}
                        </div>
                        <div className={"viewer-toolbar-item"}>
                            {toolbarSlot.zoomPopover}
                        </div>
                        <div className={"viewer-toolbar-item"}>
                            {toolbarSlot.zoomInButton}
                        </div>
                        <div className={"viewer-toolbar-item"}>
                            {toolbarSlot.downloadButton}
                        </div>
                        <div className={"viewer-toolbar-item"}>
                            <a
                                href={this.state.url}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <XAPPButton
                                    tooltip={{ "title": "Visualizar tela cheia", "placement": "top" }}
                                    type="Icon"
                                    className="py-8 px-12"
                                    onClick={() => { }}
                                    disabled={true}
                                    icon={"print"}
                                    iconProps="text-black"
                                />
                            </a>
                        </div>
                        <div className={"viewer-toolbar-item"}>
                            {toolbarSlot.fullScreenButton}
                        </div>
                        {/*<div className={"viewer-toolbar-item"}>
                         <ExportarPDFApp
                            documento={this.state.base64}
                            xappRouteParams={xappRouteParams}
                            tipo={200}
                            idfuncionalidade={idfuncionalidade}
                        /> 
                    </div> */}
                        {/* {showAssinaturaDigital &&
                        <div className={'viewer-toolbar-item'}>
                            <AssinadorApp
                                documento={this.state.base64}
                                xappRouteParams={xappRouteParams}
                                tipo={200}
                                descricao={this.props.documento.descricao}
                                arquivoAssinado={this.props.documento.arquivoAssinado}
                                iddocumento={this.props.documento.id}
                                idfuncionalidade={idfuncionalidade}
                                beforeAssinatura={beforeAssinatura}
                                afterAssinatura={afterAssinatura}
                            />
                        </div>
                    } */}
                    </div>
                </div>
            </React.Fragment>
        );
    };

    layout = (isSidebarOpened, container, main, toolbar, sidebar,) => {
        return defaultLayout(
            isSidebarOpened,
            container,
            main,
            toolbar(this.renderToolbar),
            sidebar,
        );
    };

    renderPDF = (_AValue) => {
        const pdfDocGenerator = pdfMake.createPdf(JSON.parse(_AValue));

        pdfDocGenerator.getDataUrl((_AData) => {
            const blob = this.base64toBlob(_AData);
            var url = URL.createObjectURL(blob);
            this.setState({ url: url, base64: _AData });
        });
    };

    translateTemplate = () => {
        var AStringTemplate = "";

        if (this.props.template !== undefined &&
            this.props.template !== null &&
            this.props.documento.conteudo !== undefined &&
            this.props.documento.conteudo !== null
        ) {
            var AConteudo = JSON.parse(this.props.documento.conteudo.replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r"));
            AStringTemplate = JSON.stringify(this.props.template);
            if (!_.isUndefined(this.props.template.itens) && !_.isUndefined(AConteudo.itens)) {
                var ALinhaItem = this.props.template.itens;
                var AItensResult = "";
                AConteudo.itens.forEach(item => {
                    if (AItensResult.length > 0) {
                        AItensResult += ", ";
                    }
                    AItensResult += JSON.stringify(ALinhaItem);
                    Object.keys(item).forEach(key => {
                        if (!_.isUndefined(item[key]) && !_.isNull(item[key])) {
                            AItensResult = Helpers.ReplaceAll(AItensResult.toString(), "<<#" + key.toUpperCase() + "#>>", Helpers.ReplaceAll(item[key].toString(), /[\n\r]/g, "\\n"));
                        }
                    });
                });
                AStringTemplate = Helpers.ReplaceAll(AStringTemplate.toString(), "\"<<#ITENS#>>\"", AItensResult);
            }
            Object.keys(AConteudo).forEach(key => {
                if (key.toUpperCase() === "EMPRESA_FOTO" && AConteudo[key] === "") {
                    AStringTemplate = Helpers.ReplaceAll(AStringTemplate.toString(), "<<#" + key.toUpperCase() + "#>>", "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAMSURBVBhXY/j//z8ABf4C/qc1gYQAAAAASUVORK5CYII=");
                }

                if (!_.isUndefined(AConteudo[key]) && !_.isNull(AConteudo[key])) {
                    AStringTemplate = Helpers.ReplaceAll(AStringTemplate.toString(), "<<#" + key.toUpperCase() + "#>>", Helpers.ReplaceAll(AConteudo[key].toString(), /[\n\r]/g, "\\n"));
                }
                else {
                    AStringTemplate = Helpers.ReplaceAll(AStringTemplate.toString(), "<<#" + key.toUpperCase() + "#>>", "");
                }
            });

            AStringTemplate = AStringTemplate.replace(/<<#[a-zA-Z_-]*#>>/g, "");
        }

        return AStringTemplate;
    };

    base64toBlob = (data) => {
        const base64WithoutPrefix = data.substr("data:application/pdf;base64,".length);
        const bytes = atob(base64WithoutPrefix);
        let length = bytes.length;
        let out = new Uint8Array(length);

        while (length--) {
            out[length] = bytes.charCodeAt(length);
        }

        return new Blob([out], { type: "application/pdf" });
    };

    openDialog = () => {
        this.setState({ open: !this.state.open });
    };

    render() {
        const { open, url } = this.state;
        const { classes } = this.props;

        return (
            <div className={classes.divMain}>
                {url.length > 0 &&
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.8.335/build/pdf.worker.min.js" target="_blank" without rel="noopener noreferrer">
                        <Viewer
                            fileUrl={url}
                            layout={this.layout}
                            defaultScale={md.mobile() === null && md.tablet() === null ? 1.5 : .5}
                        />
                    </Worker>
                }

                <PDFReaderDialog
                    openDialog={this.openDialog}
                    open={open}
                    url={url}
                />
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        downloadFile: Actions.downloadFile,
        getRelatorioTemplate: Actions.getRelatorioTemplate,
        clearReducer: Actions.clearReducer,
        showMessage: AppActions.showMessage,
        hideMessage: AppActions.hideMessage,
    }, dispatch);
}

function mapStateToProps({ PDFReaderApp, fuse }) {
    return {
        Formulario: PDFReaderApp,
        theme: fuse.settings.mainTheme,
        template: PDFReaderApp.template,
        file: PDFReaderApp.file
    };
}

export default withReducer("PDFReaderApp", PDFReaderReducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(PDFReaderApp))));
